import Avatar from "../Avatar";
import GameCountAndPeriod from "../GameCountAndPeriod";
import Spinner from "../Spinner";
import { DecisionTable } from "./DecisionTable";
import React, { useCallback, useMemo } from "react";
import { useEffect, useRef, useState } from "react";
import { Fail } from "../Statuses/Fail";
import { Success } from "../Statuses/Success";
import Main from "../Main/Main";
import { Start } from "../Statuses/Start";
import { getGameData, saveGameData } from "../../services/service";
import { useNavigate } from "react-router-dom";
import { NoRestart } from "../Statuses/NoRestart";

const Result = ({ initialData }) => {

	const [data, setData] = useState(initialData);
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	// remove this
	useEffect(() => {
		console.log('render Result')
	}, [])

	const restartGame = useCallback((createNewGame) => {
		console.log('createNewGame:')
		console.log(createNewGame)
		setLoading(true);
		console.log('sending restart OR create game request from Result.jsx...')

		const formData = new FormData();

		if (createNewGame) {
			console.log('CREATE NEW GAME!!!!!')
			formData.append('tx_stzplanspieloffice_decision[create_game]', true);
			formData.append('tx_stzplanspieloffice_decision[stdbp]', 1);
		} else {
			console.log('RESTART!!!!!')
			formData.append('tx_stzplanspieloffice_decision[game_restart]', true);
		}
		
		
		saveGameData(formData).then(data => {
			console.log('done!')
			console.log('is this data important?');
			console.log(data)
			// setLoading(false)
			console.log('calling getGameData...')
			getGameData().then(gameData => {
				console.log('this is gameData:')
				console.log(gameData);
				setLoading(false);
				if (createNewGame) {
					console.log('navigate to /decision')
					navigate('/decision');
				} else {
					setData(gameData);
				}
			})
		})
	}, [navigate])

	const renderElements = useMemo(() => {
		return {
			'fail': {
				element: Fail,
				message: 'Leider haben die schlechten Kennzahlen des Unternehmens dazu geführt, dass dem Unternehmen das Vertrauen entzogen wurde!'
			},
			'success': {
				element: Success,
				message: 'Success'
			},
			'start': {
				element: Start,
				message: 'Bitte beachten sie dass, wenn sie ein neues Spiel starten, werden alle Daten ihren letzes Versuches gelöscht. Inklusive ihr Punktestand.'
			},
			'norestart': {
				element: NoRestart,
				message: 'norestart'
			}
		}
	}, [])


	if (loading) {
		return <Spinner />
	}

	console.log('selecting element...')
	console.log(data);
	console.log('initialdata')
	console.log(initialData)
	const SelectedComponent = renderElements[data.status].element;
	const message = renderElements[data.status].message;

	return (
		<>
			<SelectedComponent restartGame={restartGame}/>
			<Avatar message={message} />
		</>
		
		
	)
};
export default Result;
